<template>
  <modal
    :name="modalName" 
    transition="nice-modal-fade"
    :delay="100"
    height="auto"
    :draggable="false"
  >
    <div class="example-modal-content p-3 m-6 rounded">
      <div class="flex items-center justify-end w-auto">
        <button type="submit" class="mb-2 mr-0 p-0 btn-close text-xl" @click="hide()">
          <i class="fas fa-times-circle ml-1"></i>
        </button>
      </div>
      <div
        v-if="msg_success"
        class="alert alert-success bg-green-light border border-green text-sm text-green px-4 py-3 rounded relative mb-4"
        v-html="this.msg_success"
      ></div>
      <div
        v-else-if="msg_error"
        class="alert alert-danger bg-red-lighter border border-red text-sm text-red-dark px-4 py-3 rounded relative mb-4"
        v-html="this.msg_error"
      ></div>
      <h3
        class="title-comment mb-5 pb-3 border-red-light border-b"
      >{{ $t("requests.create_comment")}}</h3>

      <sp-textarea
        theme="team"
        id="comment"
        :required="true"
        v-model="comment"
        name="comment"
        :label="isDeclaration ? $t('declarations.comment_declaration')  : $t('requests.comment_request')" :scrollable="true"
      ></sp-textarea>

      <sp-dropzone
        theme="team"
        :required="false"
        id="file_patente_id"
        :label="$t('requests.file')"
        :url="url"
        :vdropzonesuccess="CommentFileDropzoneSuccess"
        :vdropzoneError="CommentFileDropzoneError"
        tag="4"
        :vdropzone-removed-file="CommentFileDropzoneRemovedFile"
        :vdropzoneProcessing="vdropzoneProcessing"
        :maxFiles="1"
        :cinFile="response"
        :downloadFile="true"
      >
      </sp-dropzone>

      <div class="flex items-center justify-end w-auto">
        <sp-button
          theme="outline-blue"
          space="small"
          type="submit"
          class="rounded mr-0"
          :disabled="disabledAddComment"
          @click="addComment(comment)"
        >
          {{ $t("form.send")}}
          <i class="fas fa-paper-plane ml-1"></i>
        </sp-button>
      </div>
    </div>
  </modal>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import ApiService from "@/common/api.service";
import {
  SET_ApplicationMenuActive,
  SET_LabelMenuActive,
  SET_HashId,
  SET_LabelApp
} from "@/store/mutations.type";
import TextareaVue from "../../components/spKit/Textarea.vue";
import ButtonVue from "../../components/spKit/Button.vue";
import { ADD_REQUEST_COMMENT, ADD_DECLARATION_COMMENT } from "@/store/actions.type";
import Vue from "vue";
import VModal from "vue-js-modal";
import DropZoneVue from "../../components/spKit/DropZone.vue";
import { API_URL } from "@/common/config";
const uploadURL = API_URL + "/documents/upload";

Vue.use(VModal, {
  dialog: true
});
export default {
  name : "commentRequest",
  components: {
    "sp-textarea": TextareaVue,
    "sp-button": ButtonVue,
    "sp-dropzone": DropZoneVue
  },
  data() {
    return {
      comment: "",
      isSubmitted: false,
      msg_success: null,
      msg_error: null,
      url: uploadURL,
      documentId: null,
      documentPath: null,
      response: {
        id: null,
        content: ""
      },
      disabledAddComment: false,
      isDeclaration: false,
      modalName: "comment-request",
      hash: '',
      requestId: null,

    };
  },
  mounted() {
    if(this.$route.params.type){
      if(this.isInArray(parseInt(this.$route.params.type), [7,8,9,10,16,17,18,19])){
        this.isDeclaration = true;
        this.modalName = "comment-declaration"
      }
    }
    this.$store.commit(SET_LabelMenuActive, 1);
    this.$store.commit(SET_ApplicationMenuActive, 0);
    //this.$store.commit(SET_HashId, this.session.startup_application.id);
    this.$store.commit(SET_LabelApp, this.$route.params.code_label);
  },
  methods: {
    /* Add comment request candidat */
    addComment(comment) {
      this.id = this.$route.params.id;
      this.code_label = this.$route.params.code_label;
      this.request_id = this.isDeclaration ? this.$route.params.hash_id : this.$route.params.request_id;
      this.comment = comment;
      this.hash = this.$route.params.appHash;
      if(!this.comment || this.comment.replace(/\s/g, '') == ""){
        this.msg_error = this.$t("requests.field_comment_required");
      } else if (this.hash) {
        ApiService.post(
          `/api/request/add-comment`, {
            comment: this.comment,
            documentId: this.documentId,
            requestId: this.$route.params.appHash ? this.$route.params.appHash : this.hash
          }
        )
          .then(data => {
            this.$emit("add-comment", [comment, this.documentPath]);
            this.documentId = null;
            this.documentPath = null;
            setTimeout(
              function() {
                this.$modal.hide(this.modalName);
                this.msg_success = null;
                this.comment = null;
                this.msg_error = null;
                this.disabledAddComment = false
              }.bind(this),
              1500
            );
          })
          .catch(response => {
            this.$router.push({ name: "home" });
          });
      } else {
        this.disabledAddComment = true
        this.$store
        .dispatch(this.isDeclaration ? ADD_DECLARATION_COMMENT : ADD_REQUEST_COMMENT, {
          label: this.$route.params.code_label,
          type_id: this.isDeclaration ? this.$route.params.type : this.$route.params.id,
          request_id: this.request_id,
          comment: this.comment,
          documentId: this.documentId
        })
        .then(data => {
          this.msg_success = data.meta.messages[0];
          this.$emit("add-comment", [comment, this.documentPath]);
          this.documentId = null;
          this.documentPath = null;
          setTimeout(
            function() {
              this.$modal.hide(this.modalName);
              this.msg_success = null;
              this.comment = null;
              this.msg_error = null;
              this.disabledAddComment = false
            }.bind(this),
            1500
          );
        })
        .catch(({ response }) => {
          this.msg_error = response.data.meta.messages[0];
          this.disabledAddComment = false
        });
      }
      
    },
    hide() {
      this.$modal.hide(this.modalName);
      this.msg_success = null;
      this.comment = null;
      this.msg_error = null;
    },
    vdropzoneProcessing(file) {
      this.inProgress = true;
    },
    CommentFileDropzoneSuccess(file, response) {
      this.inProgress = false;
      this.documentPath = response.data.document.path
      this.documentId = response.data.document.id;
    },
    CommentFileDropzoneError(file, message, xhr) {
      if (xhr != undefined) {
        if (message.meta.status == 400) this.documentId = null;
      }
      this.$el.getElementsByClassName("dz-error-message")[0].innerHTML =
        "you cant upload this file";
    },
    CommentFileDropzoneRemovedFile(file, error, xhr) {
      this.documentId = null;
      this.documentPath = null;
    },
    isInArray(value, array) {
      return array.indexOf(value) > -1;
      }
  },

  computed: {
    ...mapGetters([
      "session",
      "ApplicationMenuActive",
      "LabelMenuActive",
      "hashId",
      "LabelApplication",
      "requestForm"
    ]),
    ...mapState({
      errors: state => state.session.errors
    })
  }
};
</script>


<style scoped>
.title-comment {
  font-size: 1.125rem;
  color: #ee0049;
}

.btn-close {
  color: #ee0049;
}
</style>